import styled from "styled-components";
import {
  siteDarkBlue,
  sitePurple,
  siteLightBlue,
  siteDarkGreen
} from "../../providers/Theme";

export const Section = styled.section`
  background: white;
  padding: 4rem 1.5rem;
  text-align: center;
`;

export const SectionHeading = styled.h2`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2.5rem;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  max-width: 56rem;
  margin: 0 auto;

  ${({ theme }) => theme.md`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const StatCard = styled.div<{ bg: string }>`
  background: ${({ bg }) => bg};
  border-radius: 14px;
  padding: 2rem 2rem 2.25rem;
  text-align: left;
  color: white;
`;

export const StatNumber = styled.p`
  font-weight: 800;
  font-size: 2.4rem;
  line-height: 1.05;
  margin-bottom: 0.6rem;

  ${({ theme }) => theme.md`
    font-size: 2.8rem;
  `}
`;

export const StatBody = styled.p`
  font-size: 1.35rem;
  line-height: 1.5;
  margin: 0;
  font-weight: 400;

  strong {
    font-weight: 700;
  }
`;

export const cardBg = {
  purple: sitePurple,
  blue: siteLightBlue,
  green: siteDarkGreen,
  darkBlue: siteDarkBlue
};
